import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import type { Faq } from '../../types/content';
interface FaqListProps {
  items: Faq[];
}
export function FaqList({
  items
}: FaqListProps) {
  const [open, setOpen] = useState<number | null>(0);
  return <ul className="divide-y divide-line border-y border-line" data-id="element-775" data-mp="2v5m1sbhkyemm">
      {items.map((item, index) => {
      const isOpen = open === index;
      const panelId = `faq-panel-${index}-${item.q.length}`;
      return <li key={item.q} data-id="element-776" data-mp="22ihqjorw942e" data-mpi={index}>
            <h3 className="font-sans" data-id="element-777" data-mp="27hb75q2h9b6s">
              <button type="button" className="flex w-full items-center justify-between gap-6 py-5 text-left type-accordion text-ink" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : index)} data-id="element-778" data-mp="27g9slbm966kb">
                {item.q}
                <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-brand ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-779" data-mp="1jpdxo5mi2v8u" />
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-780" data-mp="1wok0dwq5sf78">
              {isOpen ? <motion.div id={panelId} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-781" data-mp="1rra01m18ej4m">
                  <p className="max-w-3xl pb-6 type-body" data-id="element-782" data-mp="1dstx866hpcrr">{item.a}</p>
                </motion.div> : null}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}